module.exports = __webpack_public_path__ + "img/awaiting.212693e5.png";